import React from "react";

import { Container } from "../components";

import Base from "./utils/Base";

const libFiles = ["js-example.js", "css-example.css"];

export default () => {
  return (
    <Base includeLibs={libFiles} scope="static">
      <Container>
        <h1>Look ma, lib files!</h1>
        <p>
          Look into console{" "}
          <span role="img" aria-label="wink">
            😉
          </span>
          .
        </p>
        <p>
          <span className="example">And this is blue from lib file too.</span>
        </p>
      </Container>
    </Base>
  );
};
